export { SpaClassCompactCard } from './SpaClassCompactCard';
export type { SpaClassCompactCardProps } from './SpaClassCompactCard.types';
